import { ArtistHubContent } from "@/features/artist-hub/artist-hub-content";
import { Route } from "/app/apps/web/src/routes/_app/$lang/artists/index.tsx";
function ArtistHubRoute() {
  const {
    locale
  } = Route.useLoaderData();
  return <ArtistHubContent locale={locale} />;
}
export { ArtistHubRoute as component };